// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2NAYX","errorLogs":"styles_errorLogs__2ZfhS"};